import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![gitBranchPlusIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNNiAzdjEyTTE4IDlhMyAzIDAgMSAwIDAtNiAzIDMgMCAwIDAgMCA2TTYgMjFhMyAzIDAgMSAwIDAtNiAzIDMgMCAwIDAgMCA2Ii8+PHBhdGggZD0iTTE1IDZhOSA5IDAgMCAwLTkgOU0xOCAxNXY2TTIxIDE4aC02Ii8+PC9zdmc+) */
const gitBranchPlusIcon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 3v12M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  }), /*#__PURE__*/jsx("path", {
    d: "M15 6a9 9 0 0 0-9 9M18 15v6M21 18h-6"
  })]
});

export { gitBranchPlusIcon };
